import React from "react";
import Box from "@mui/material/Box";
import Logo1 from "./../assets/images/Azvasa_logo.png";
import Logo2 from "./../assets/images/logo.svg";
import Logo3 from "./../assets/images/logo-emblem--dark.svg";


const HEIGHT = 200;
const WIDTH = 70;

const colors = {
  light: "light",
  dark: "dark",
};

const LogoProps = {
  color: colors.dark,
  emblem: false,
  height: HEIGHT,
  width: WIDTH,
};

export function Logo(props = LogoProps) {
  const {
    color = props.color,
    emblem = props.emblem,
    height = props.height,
    width = props.width,
  } = props;
  let url;
  if (emblem) {
    url = color !== colors.light ? Logo1 : Logo3;
  } else {
    url = color == colors.light ? Logo1 : Logo2;
  }

  // if (emblem) {
  //   url = color !== colors.light ? './../images/logo-emblem.svg' : './../images/logo-emblem--dark.svg';
  // } else {
  //   url = color == colors.light ? './../images/logo.svg' : './../images/logo--dark.svg';
  // }

  return (
    <Box alt="logo" component="img" height={height} src={url} width={width} />
  );
}

const DynamicLogoProps = {
  colorDark: colors.light,
  colorLight: colors.dark,
  emblem: false,
  height: HEIGHT,
  width: WIDTH,
};

export function DynamicLogo(props = DynamicLogoProps) {
  const {
    colorDark = props.colorDark,
    colorLight = props.colorLight,
    emblem = props.emblem,
    height = props.height,
    width = props.width,
    ...rest
  } = props;
  const colorScheme = "dark";
  const color = colorScheme === "dark" ? colorDark : colorLight;

  return <Logo color={color} height={height} width={width} {...rest} />;
}
